import { Zap, Users, BadgePercent, Clock } from "lucide-react";

const cards = [
  {
    icon: Zap,
    title: "Qu'est-ce qu'un CEE ?",
    body: "Créé par la loi POPE en 2005, le Certificat d'Économies d'Énergie est un mécanisme qui oblige les fournisseurs d'énergie (« obligés ») à financer des actions concrètes d'efficacité énergétique. Chaque kWh économisé sur la durée de vie de l'équipement génère des certificats valorisables.",
  },
  {
    icon: Users,
    title: "Qui peut en bénéficier ?",
    body: "Tous les acteurs économiques : entreprises industrielles, exploitants tertiaires, gestionnaires de patrimoine, copropriétés, bailleurs, et particuliers. Chaque profil bénéficie d'un catalogue d'opérations standardisées avec des montants forfaitaires.",
  },
  {
    icon: BadgePercent,
    title: "Pourquoi jusqu'à 100 % financé ?",
    body: "Certaines opérations standardisées (Coup de Pouce, BAT-TH-104, IND-UT…) cumulées avec d'autres aides peuvent couvrir l'intégralité du coût des travaux — voire générer un bonus dans certains cas spécifiques aux ménages en précarité énergétique.",
  },
  {
    icon: Clock,
    title: "Pourquoi agir maintenant ?",
    body: "La 5ᵉ période CEE arrive à échéance, les volumes obligataires augmentent à chaque période et les fiches d'opérations sont régulièrement révisées à la baisse. Sécuriser sa valorisation aujourd'hui, c'est garantir un meilleur niveau d'aide.",
  },
];

export default function CEEExplainer() {
  return (
    <section data-testid="cee-explainer" className="relative bg-gradient-to-b from-white to-[#F1F5F9] border-y border-black/5">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-3xl mb-16">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Comprendre les CEE</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
            Un dispositif d&apos;État puissant — encore largement sous-utilisé.
          </h2>
          <p className="mt-6 text-[#475569] md:text-lg leading-relaxed">
            Le mécanisme des Certificats d&apos;Économies d&apos;Énergie est complexe, technique et
            évolue chaque année. ECONATION le maîtrise depuis ses débuts.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {cards.map((c) => (
            <article
              key={c.title}
              data-testid={`cee-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group relative bg-white/70 backdrop-blur-xl rounded-2xl border border-white/60 p-8 hover:border-[#10B981]/40 transition-all hover:shadow-[0_24px_60px_-30px_rgba(16,185,129,0.3)]"
            >
              <div className="h-12 w-12 rounded-xl bg-[#064E3B] grid place-items-center text-[#10B981] mb-5 group-hover:bg-[#10B981] group-hover:text-white transition-colors">
                <c.icon className="h-5 w-5" strokeWidth={1.75} />
              </div>
              <h3 className="font-display text-xl md:text-2xl font-semibold text-[#0F172A] mb-3 tracking-tight">{c.title}</h3>
              <p className="text-[#475569] leading-relaxed">{c.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
